@if (referral(); as referral) {
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <pr-referral-menu-status-buttons
      [referral]="referral"
      (updateStatus)="updateStatus.emit($event)"
    />

    <mat-divider />

    <button *prIsManagement mat-menu-item (click)="preview.emit()">
      <mat-icon>preview</mat-icon>
      <span>Preview</span>
    </button>

    <button
      mat-menu-item
      class="!text-warn-500"
      (click)="deleteReferral.emit(referral)"
    >
      <mat-icon class="!text-warn-500">delete</mat-icon>
      <span>Delete</span>
    </button>
  </mat-menu>
}
